/**
 * 서류 등록 v1 장비 상세 — 화면은 $j.F.Docs.v1.Detail 가 그린다. 서버 값은 #page-data
 * ($j.Pages.Mobile.DocsV1Car / body data-page-name="DocsV1Car")
 */
export default class DocsV1Car {
    initialize() {
        $j.Ui.Div.open({
            id: 'docs-v1-host',
            target: '$j.F.Docs.v1.Detail',
            data: JSON.parse(document.getElementById('page-data')?.textContent || '{}'),
        });
    }
}
